import { Component, Input } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { ApiServiceService } from 'src/app/Services/api-service.service';

@Component({
  selector: 'app-view-custom-mda-details',
  templateUrl: './view-custom-mda-details.component.html',
  styleUrls: ['./view-custom-mda-details.component.css']
})
export class ViewCustomMdaDetailsComponent {
customPrices: any[];

@Input() id: number;

constructor(
  private bsModalRef: BsModalRef,
  private apiService: ApiServiceService,
 
) {}

ngOnInit(): void {


  this.fetchCustomDetails(this.id)

}


fetchCustomDetails(id: number): void {
  const url = "/assessments/mda/custom/details/list?id=" + id;
  this.apiService.get(url).subscribe((res: any) => {
    this.customPrices = res?.data || [];
  });
}



close(): void {
  this.bsModalRef.hide();
}

}
